import { MAX_FULL_QUALITY, MAX_TILES, type PlatformClass } from '@multiview/shared';

const OVERRIDE_KEY = 'multiview.platform';

function detect(): PlatformClass {
  const ua = navigator.userAgent;

  // Android TV reports "Android" with a TV marker and no touch digitiser. The
  // distinction matters because the tile ceiling differs by a factor of two.
  if (/\bGoogle TV\b|\bAndroid TV\b|\bSMART-TV\b|\bTizen\b|\bWeb0S\b|CrKey/i.test(ua)) return 'tv';
  if (/Android/i.test(ua) && navigator.maxTouchPoints === 0) return 'tv';
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return 'mobile';
  return 'desktop';
}

/**
 * Resolved once per load. The override exists so TV behaviour -- tile ceiling,
 * 10-foot spacing, D-pad-only interaction -- can be exercised on a desktop
 * browser without an actual TV box, via `?platform=tv`.
 */
export const platform: PlatformClass = (() => {
  const fromQuery = new URLSearchParams(location.search).get('platform');
  if (fromQuery === 'tv' || fromQuery === 'desktop' || fromQuery === 'mobile') {
    try {
      localStorage.setItem(OVERRIDE_KEY, fromQuery);
    } catch { /* ignore */ }
    return fromQuery;
  }
  try {
    const stored = localStorage.getItem(OVERRIDE_KEY);
    if (stored === 'tv' || stored === 'desktop' || stored === 'mobile') return stored;
  } catch { /* ignore */ }
  return detect();
})();

export const maxTiles: number = MAX_TILES[platform];
export const maxFullQuality: number = MAX_FULL_QUALITY[platform];
export const isTv = platform === 'tv';
